import { render, staticRenderFns } from "./JourneyDetails.vue?vue&type=template&id=2ba387e6"
import script from "./JourneyDetails.vue?vue&type=script&lang=js"
export * from "./JourneyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports